(function () {
  "use strict";

  var step = document.querySelector("[data-secure-prescription-step]");
  if (!step) return;

  var frame = step.querySelector("[data-secure-prescription-frame]");
  var loading = step.querySelector("[data-secure-intake-loading]");
  var triggers = document.querySelectorAll("[data-secure-intake-trigger]");
  var healthConsent = document.querySelector("[data-health-data-consent]");
  var healthConsentOptions = document.querySelector("[data-health-consent-options]");
  var healthConsentError = document.querySelector("[data-health-consent-error]");
  var healthConsentVersion = healthConsent
    ? healthConsent.dataset.healthDataConsentVersion || ""
    : "";
  var allowedUsageTypes = ["single_vision", "bifocal", "computer", "progressive"];
  var selectedUsageType = "";
  var selectedSubmissionMethod = "manual";
  var contextToken = "";
  var frameReady = false;
  var modal = step.closest(".Modal_Popup");
  var appOrigin = "";
  var contextUrl = "";
  var embedUrl = "";
  var preparing = false;
  var completedSubmission = null;
  var activeFrameSession = null;

  function dispatchCompletedSubmission(submission) {
    document.dispatchEvent(
      new CustomEvent("illusion:secure-prescription-complete", {
        detail: {
          submissionReference: submission.reference,
          prismSurcharge: submission.prismSurcharge,
          prismVariantId: step.dataset.prismVariantId || "",
          prismPrice: step.dataset.prismPrice || "0",
        },
      }),
    );
  }

  function configureApp() {
    try {
      var url = new URL(step.dataset.appUrl);
      if (
        url.protocol !== "https:" ||
        url.username ||
        url.password ||
        url.search ||
        url.hash ||
        (url.pathname !== "/" && url.pathname !== "")
      ) {
        throw new Error("Invalid secure app URL");
      }
      appOrigin = url.origin;
      contextUrl = appOrigin + "/intake/prescription/context/";
      embedUrl = appOrigin + "/intake/prescription/embed/";
      return true;
    } catch (_error) {
      showError("The secure prescription form is not configured. Please contact the store.");
      return false;
    }
  }

  function showError(message) {
    step.classList.add("has-error");
    loading.hidden = false;
    loading.textContent = message;
    frame.classList.remove("is-ready");
  }

  function showLoading(message) {
    step.classList.remove("has-error");
    loading.hidden = false;
    loading.textContent = message;
    frame.classList.remove("is-ready");
  }

  function syncHealthConsentGate() {
    var accepted = Boolean(healthConsent && healthConsent.checked);
    if (healthConsentOptions) {
      healthConsentOptions.hidden = false;
      healthConsentOptions.classList.toggle("is-consent-locked", !accepted);
      if (accepted) healthConsentOptions.removeAttribute("inert");
      else healthConsentOptions.setAttribute("inert", "");
    }
    triggers.forEach(function (trigger) {
      if (!healthConsentOptions || !healthConsentOptions.contains(trigger)) return;
      trigger.setAttribute("aria-disabled", accepted ? "false" : "true");
    });
    if (healthConsentError && accepted) healthConsentError.hidden = true;
  }

  function requireHealthConsent() {
    if (healthConsent && healthConsent.checked && healthConsentVersion) return true;
    if (healthConsentError) {
      healthConsentError.hidden = false;
      healthConsentError.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    if (healthConsent) healthConsent.focus();
    return false;
  }

  function currentVariantId() {
    var selectedVariant = document.querySelector('input[name="id"]');
    var value = selectedVariant ? selectedVariant.value : step.dataset.productVariantId;
    return /^[0-9]{1,32}$/.test(value || "") ? value : "";
  }

  function postContextToFrame() {
    if (!frameReady || !contextToken || !selectedUsageType || !frame.contentWindow) return;
    frame.contentWindow.postMessage(
      {
        type: "illusion:prescription-context",
        contextToken: contextToken,
        usageType: selectedUsageType,
        submissionMethod: selectedSubmissionMethod,
      },
      appOrigin,
    );
    loading.hidden = true;
    frame.classList.add("is-ready");
  }

  function sessionMatches(session, variantId) {
    return Boolean(
      session &&
      session.variantId === variantId &&
      session.usageType === selectedUsageType &&
      session.submissionMethod === selectedSubmissionMethod
    );
  }

  function resumeSecureForm(editCompletedSubmission) {
    if (!frameReady || !activeFrameSession || !frame.contentWindow) return false;
    if (modal) modal.classList.add("secure-intake-active");
    step.style.display = "block";
    loading.hidden = true;
    frame.classList.add("is-ready");
    if (editCompletedSubmission) {
      frame.contentWindow.postMessage(
        { type: "illusion:prescription-edit" },
        appOrigin,
      );
    }
    frame.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  }

  async function prepareSecureForm() {
    if (!requireHealthConsent()) return;
    var variantId = currentVariantId();
    if (!appOrigin || !variantId || allowedUsageTypes.indexOf(selectedUsageType) === -1) {
      showError("The secure prescription form could not be prepared. Please go back and try again.");
      return;
    }

    var activeSessionMatches = sessionMatches(activeFrameSession, variantId);
    var completedSubmissionMatches = sessionMatches(completedSubmission, variantId);
    if (
      activeSessionMatches &&
      resumeSecureForm(completedSubmissionMatches)
    ) {
      return;
    }
    if (preparing) return;
    preparing = true;

    contextToken = "";
    frameReady = false;
    activeFrameSession = null;
    if (modal) modal.classList.add("secure-intake-active");
    showLoading("Preparing the secure prescription form…");
    frame.src = embedUrl;

    try {
      var response = await fetch(contextUrl, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        referrerPolicy: "no-referrer",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          product_variant_id: variantId,
          usage_type: selectedUsageType,
          submission_method: selectedSubmissionMethod,
          health_data_consent_accepted: true,
          health_data_consent_version: healthConsentVersion,
        }),
      });
      var result = await response.json();
      if (
        !response.ok ||
        typeof result.context_token !== "string" ||
        result.context_token.length < 1 ||
        result.context_token.length > 2048
      ) {
        throw new Error("Context rejected");
      }
      contextToken = result.context_token;
      activeFrameSession = {
        variantId: variantId,
        usageType: selectedUsageType,
        submissionMethod: selectedSubmissionMethod,
      };
      postContextToFrame();
    } catch (_error) {
      activeFrameSession = null;
      showError("The secure prescription form is temporarily unavailable. Please try again.");
    } finally {
      preparing = false;
    }
  }

  document.addEventListener("click", function (event) {
    var usage = event.target.closest("[data-prescription-usage]");
    if (usage && allowedUsageTypes.indexOf(usage.dataset.prescriptionUsage) !== -1) {
      selectedUsageType = usage.dataset.prescriptionUsage;
    }
  });

  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      if (!healthConsent || !healthConsent.checked || !healthConsentVersion) {
        event.preventDefault();
        event.stopPropagation();
        requireHealthConsent();
        return;
      }
      selectedSubmissionMethod = trigger.dataset.submissionMethod === "upload"
        ? "upload"
        : "manual";
      prepareSecureForm();
    });
  });

  if (healthConsent) {
    healthConsent.addEventListener("change", syncHealthConsentGate);
    syncHealthConsentGate();
  }

  document.addEventListener("illusion:secure-prescription-edit", function () {
    if (!completedSubmission) return;
    resumeSecureForm(true);
  });

  window.addEventListener("message", function (event) {
    if (event.origin !== appOrigin || event.source !== frame.contentWindow) return;
    var message = event.data;
    if (!message || typeof message !== "object" || Array.isArray(message)) return;

    var keys = Object.keys(message).sort().join(",");
    if (keys === "type" && message.type === "illusion:prescription-ready") {
      frameReady = true;
      postContextToFrame();
      return;
    }
    if (keys === "type" && message.type === "illusion:prescription-back") {
      if (modal) modal.classList.remove("secure-intake-active");
      step.style.display = "none";
      var fillMethod = document.querySelector('.steps[current-step="fillPrescription"]');
      if (fillMethod) fillMethod.style.display = "block";
      return;
    }
    if (
      keys === "height,type" &&
      message.type === "illusion:prescription-resize" &&
      Number.isInteger(message.height) &&
      message.height >= 560 &&
      message.height <= 5000
    ) {
      frame.style.height = message.height + "px";
      return;
    }
    if (keys === "type" && message.type === "illusion:prescription-scroll") {
      frame.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    if (
      keys === "direction,type" &&
      message.type === "illusion:prescription-focus-boundary" &&
      (message.direction === "forward" || message.direction === "backward")
    ) {
      document.dispatchEvent(
        new CustomEvent("illusion:prescription-focus-boundary", {
          detail: { direction: message.direction },
        }),
      );
      return;
    }
    if (keys === "type" && message.type === "illusion:prescription-close") {
      document.dispatchEvent(new CustomEvent("illusion:prescription-close"));
      return;
    }
    if (
      keys === "prismSurcharge,status,submissionReference,type" &&
      message.type === "illusion:prescription-complete" &&
      message.status === "accepted" &&
      typeof message.prismSurcharge === "boolean" &&
      typeof message.submissionReference === "string" &&
      /^rx_[A-Za-z0-9_-]{32,61}$/.test(message.submissionReference)
    ) {
      contextToken = "";
      completedSubmission = {
        reference: message.submissionReference,
        prismSurcharge: message.prismSurcharge,
        variantId: currentVariantId(),
        usageType: selectedUsageType,
        submissionMethod: selectedSubmissionMethod,
      };
      if (modal) modal.classList.remove("secure-intake-active");
      dispatchCompletedSubmission(completedSubmission);
    }
  });

  configureApp();
})();
